module.exports = __webpack_public_path__ + "img/conus.51ee6fd0.svg";